import Client from "../shared/services/Client";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function sendOnboardingEmail(email: string, os: string): Promise<any> {
    return Client.post("/api/onboarding/email/download", { email, os });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function fetchNextPage(email: string, page: string, order: string): Promise<any> {
    return Client.post("/api/onboarding/next-page", { email, page, order });
}
